import { generateConfig, getAccessToken } from '../apiConfig'
import settings from 'settings/index'
import axios from 'axios'
import StorageManager from 'helpers/storageManager.js'

export const {
  APIURL,
  ICAS_API_KEY,
  ICAS_API_URL,
  ICAS_AUTHORIZATION_URL,
  googleApiKey,
  ACTIVE_WORKSPACE_STORAGE_KEY,
} = settings

export const config = (additionalSettings = {}) =>
  generateConfig(getAccessToken(), additionalSettings)

// TODO: use axios interceptors to process the response and
// get rid of `The` function all over the code
// or convert to ts so the typing and autocomplete of axios methods work
export const httpClient = axios

export const getCurrentWorkspace = () =>
  StorageManager.read(ACTIVE_WORKSPACE_STORAGE_KEY)
